import { Schema } from 'effect';

// v4: schema `message` annotations must be plain strings (the v3
// `() => { override, message: Effect<string> }` shape was removed). The i18n
// IntlContext-aware error message system needs to be re-applied at the
// formatter layer rather than as a per-check annotation — see
// `helper.ts:prepareDecodeUnknownEitherWithFormatterIntl`.
// Keep the localized type error while rejecting non-finite numbers.
// `Schema.Finite.annotate` moves the message off the type check.
// @effect-diagnostics-next-line schemaNumber:off -- the `isFinite` check below rejects NaN and Infinity.
export const Number = Schema.Number.annotate({ message: 'Hodnota musí být číslo' }).check(
  Schema.isFinite()
);

export const Integer = Number.check(
  Schema.isInt({
    message: 'Hodnota musí být celé číslo',
  })
);

export const IntegerNatural = Integer.check(
  Schema.isGreaterThanOrEqualTo(0, {
    message: 'Hodnota musí být přirozené číslo',
  })
);

export const IntegerInRange = (min: number, max: number) =>
  Integer.check(
    Schema.isBetween(
      { minimum: min, maximum: max },
      {
        message: `Hodnota musí být mezi ${String(min)} a ${String(max)}`,
      }
    )
  );
